import cardStockEn from "./card-stock/en";
import type inventoryId from "./id";
import stockAdjustmentEn from "./stock-adjustment/en";
import stockInEn from "./stock-in/en";
import stockOutEn from "./stock-out/en";
import stockTransferEn from "./stock-transfer/en";

const inventoryEn: typeof inventoryId = {
	inventory: {
		...cardStockEn,
		...stockInEn,
		...stockOutEn,
		...stockTransferEn,
		...stockAdjustmentEn,
	},
};

export default inventoryEn;
